import Routes from '@brainstud/react-tbl/themes/pgw/v1/routes'

export const selectNavigation = (state, props, hasRole) => {
  const user = state.account.user
  const navigationById = state.navigation.list.byId
  const navigationIds = state.navigation.list.allIds
  const navigationProgress = state.navigation.progress

  const navigation = navigationIds.reduce((acc, id) => {
    const item = navigationById[id]

    return acc.concat({
      ...item,
      progress: navigationProgress[id],
      url: item.type === 'endtest' ? Routes.to('endtest') : null,
    })
  }, [])

  return hasRole && user.role === 'student'
    ? navigation.filter(item => item.role !== 'coach')
    : navigation
}

export const selectChapters = (state, props) => {
  const chaptersById = state.chapters.chapters.byId
  const chaptersIds = state.chapters.chapters.allIds
  const chaptersProgress = state.chapters.progress
  const lessonsById = state.chapters.lessons.byId

  return chaptersIds.reduce((acc, id) => {
    const chapter = chaptersById[id]
    const navigation = selectNavigation(state, props).find(item => item.chapterId === chapter.id)

    return acc.concat({
      ...chapter,
      navigation,
      url: Routes.to('chapter', { chapter: chapter.slug }),
      lessonUrl: chaptersProgress[chapter.slug]
        ? Routes.to('lesson', { chapter: chapter.slug, lesson: chaptersProgress[chapter.slug] })
        : Routes.to('lesson', { chapter: chapter.slug, lesson: chapter.lessons[0].slug }),
      lessons: chapter.lessons.map(id => ({
        ...lessonsById[id],
        url: Routes.to('lesson', { chapter: chapter.slug, lesson: lessonsById[id].slug }),
        options: { ...lessonsById[id].options },
        data: chaptersProgress[id],
      })),
    })
  }, [])
}

export const selectChapter = (state, props) => {
  return selectChapters(state, props).find(item => item.slug === props.match.params.chapter)
}

export const selectPages = (state, props) => {
  const pagesById = state.pages.list.byId
  const pagesIds = state.pages.list.allIds
  const pagesProgress = state.pages.progress

  return pagesIds.reduce((acc, id) => {
    const page = pagesById[id]
    const navigation = selectNavigation(state, props).find(item => item.pageId === page.id)

    return acc.concat({
      ...page,
      navigation,
      url: Routes.to('page', { page: page.slug }),
    })
  }, [])
}

export const selectPage = (state, props) => {
  return selectPages(state, props).find(item => item.slug === props.match.params.page)
}
